// extracted by mini-css-extract-plugin
module.exports =  {"formWrap":"formWrap___uGRz0","message":"message___seIzJ","title":"title___dFOuH","inputFields":"inputFields___3bZbh","submit":"submit___BXwDe"};